module.exports = __webpack_public_path__ + "static/media/video-17-tt.4687ca56.webm";